import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { Section } from './Shared';
import { faqs } from '../data/landing';
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="max-w-3xl" data-id="element-50" data-mp="1cf05lglr3epm">
      <h2 className="text-[28px] md:text-5xl font-display font-bold leading-tight text-brand-purpleDark text-center" data-id="element-51" data-mp="1cft6w21xxc0d">
        ❓ Preguntas frecuentes
      </h2>

      <div className="mt-10 divide-y divide-brand-purple/15 border-y border-brand-purple/15" data-id="element-52" data-mp="252m80lj8sdaw">
        {faqs.map((faq, i) => {
        const open = openIndex === i;
        return <div key={faq.q} data-id="element-53" data-mp="1v5841lei9gzh" data-mpi={i}>
              <button type="button" onClick={() => setOpenIndex(open ? null : i)} aria-expanded={open} className="w-full py-5 text-left flex justify-between items-center gap-4" data-id="element-54" data-mp="1v3y2unccvsom">
                <span className="font-serif font-semibold text-base md:text-lg text-brand-purpleDark" data-id="element-55" data-mp="1knqjhk8slm3h">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-brand-goldDark shrink-0 transition-transform duration-200 ${open ? 'rotate-180' : ''}`} data-id="element-56" data-mp="1plibee9ft87o" />
              </button>
              <AnimatePresence initial={false} data-id="element-57" data-mp="1fnc7xs7zfu0p">
                {open && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-58" data-mp="11wyzzpv3cfbd">
                    <p className="pb-5 text-base text-brand-text/85 leading-relaxed" data-id="element-59" data-mp="ww1lpod7c5f5">
                      {faq.a}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>
    </Section>;
};